import { Component, OnInit } from '@angular/core';
//import { GuardService } from 'projects/client-app/src/app/modules/profile/services/guard.service';
import { GuardsService } from '../../services/guards.service';
import { AuthService } from '../../../auth/services/auth.service';
import { FormControl } from '@angular/forms';
import { arLocale, defineLocale, enGbLocale } from 'ngx-bootstrap/chronos';
import { LangService, convertDateToString, language } from 'projects/tools/src/public-api';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { map } from 'rxjs';

@Component({
  selector: 'app-honorboard',
  templateUrl: './honorboard.component.html',
  styleUrls: ['./honorboard.component.scss']
})
export class HonorboardComponent implements OnInit {
 Honordata!:any;
 companyId!: any;
 top5AttendanceGuard!:any;
 top5SupervisorAttendance!:any;
 top5ProductiveGuard!:any;
 date = new FormControl(new Date());
 maxDate = new Date();
 start!: any;
 end!: any;
 filter: boolean = false;
  constructor( private auth: AuthService,private _guradService:GuardsService ,  public lang: LangService , private localeService: BsLocaleService) { 
    this.companyId = this.auth.snapshot.userInfo?.id;
    console.log(this.companyId);
    this.initDatePiker();
  }

  ngOnInit(): void {
    this.onDateChange();
    this.getHonorBoardData();
  }


  initDatePiker() {
    defineLocale('ar', arLocale);
    defineLocale('en', enGbLocale);
    this.lang.language.subscribe((res) => {
      res === language.ar
        ? this.localeService.use('ar')
        : this.localeService.use('en');
    });
  }

  onDateChange() {
    this.date.valueChanges
      .pipe(
        map((val: any) => ({
          start: convertDateToString(val[0]),
          end: convertDateToString(val[1]),
          
        }))
      )
      .subscribe((val) => {
        if(this.date.touched == true){
          console.log("true");
          this.filter=true;
        }
        this.getHonorBoardData();
      });
      console.log(this.date);
      if(this.date.touched == true){
        console.log("true");
        
      }
  }

  getHonorBoardData(){
    let date: any;
    if (this.filter == false) {
      date = convertDateToString(new Date());
      let currentDate = new Date();
      currentDate.setDate(1);
      this.start = convertDateToString(currentDate);
      this.end = date;
      console.log(this.start , this.end);
      
    } else {
      date = this.date.value;
      this.start = convertDateToString(date[0]);
      this.end = convertDateToString(date[1]);
    }
    console.log(this.start ,this.end );
    
  this._guradService.honorData(this.companyId , this.start , this.end).subscribe((res)=>{
    this.Honordata=res;
    console.log(this.Honordata);
    this.top5AttendanceGuard=this.Honordata.top5AttendanceGuard;
    this.top5SupervisorAttendance=this.Honordata.top5SupervisorAttendance;
    this.top5ProductiveGuard = this.Honordata.top5ProductiveGuard;
  })
  }

  deleteFilter(){
    this.filter=false;
    this.getHonorBoardData();
  }
}
